import * as Styled from './styled'

interface IProps {
  isVisible: boolean
  fromTop?: boolean
  isTop?: boolean
}

export const ItemForShadowEffect: React.FC<IProps> = props => {
  const { isVisible, fromTop, isTop } = props

  return (
    <Styled.ItemForShadowEffectWrapper
      $isVisible={isVisible}
      $fromTop={!!fromTop}
      $isTop={!!isTop}
    />
  )
}
